/* eslint-disable no-lonely-if */
/* eslint-disable array-callback-return */
/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
// eslint-disable-next-line simple-import-sort/imports
import { FC } from 'react';
import { useStyles } from './style';


interface IScore {
    listScore: any[];
}

const Score: FC<IScore> = ({
    listScore
}) => {

    const classe = useStyles();

    return (
        <>
            <div className={classe.root}>

                {
                    listScore.map((item: any, index: number) =>
                        <>

                            <div
                                className={classe.score}
                                style={{
                                    backgroundColor: item?.isMax ? '#FFDC27' : '#0E1247',
                                    justifyContent: index === 0 ? 'flex-start' : 'flex-end',
                                    color: item?.isMax ? '#0E1247' : '#fff',
                                    fontWeight: item?.isMax ? 'bold' : 500,
                                    width: `${item?.pourcentage}%`
                                }}
                            >
                                {`${Math.round(((item?.pourcentage) + Number.EPSILON) * 100) / 100}%`}
                            </div>

                        </>
                    )
                }

            </div>

            <div className={classe.root}>

                {
                    listScore.map((item: any, index: number) =>
                        <>
                            <div
                                className={classe.textContent}
                                style={{
                                    display: 'flex',
                                    fontWeight: item?.isMax ? 'bold' : 500,
                                    justifyContent: index === 0 ? 'flex-start' : 'flex-end',
                                }}
                            >
                                {item?.label || ""}
                            </div>

                        </>
                    )
                }
            </div>

        </>

    );
};

export default Score; 